import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Select from "react-select";
import debounce from "lodash/debounce";
import { withRouter } from "react-router-dom";
import { FormGroup, Button, Col, Row, FormControl, Checkbox, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import AdminService from "../../../services/AdminService";
import ProjectsService from "../../../services/ProjectsService";
import PackagesService from "../../../services/PackagesService";
import SearchService from "../../../services/SearchService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import LoadingSVG from "../../helpers/LoadingSVG";
import InlineError from "../../messages/InlineError";   
import AreasContainer from "../../partials/areas/Container";
import StandaloneFields from "./fields/StandaloneFields";
import PayAsYouGoFields from "./fields/PayAsYouGoFields";
import RecurringFields from "./fields/RecurringFields";
import PackageFields from "./fields/PackageFields";
import PackageArea from "./partials/PackageArea";
import AreasService from "../../../services/AreasService";
import ExtraHoursFields from "./fields/ExtraHoursFields";
import { dataToSelectOption } from "../../helpers/HelperFunctions";

class ProjectCreateForm extends Component {

    state = {
    	selectedDate: null, 
    	selectedCustomer: null,
    	selectedManager: null,
    	selectedProject: null,
    	selectedType: null,
    	isLoadingPackages: false,
    	isLoadingPackageData: false,
    	isLoadingAreas: false,
    	isLoadingCustomer: false,
    	saveProjectLoading: false,
    	directLogging: false,
    	packageAreas: [],
    	packages: [],
    	statuses: [],
    	areas: [],
    	formData:{ 
    		areas: [],
    		tasks: [],
    		status: "Active"
    	},
    	errors:{},		
    }
	
	componentDidMount = () => {
		// if the user is coming from projec info page, set selected data
		const { state } = this.props.location;
		if( state !== undefined) {
			this.setState({ 
				...this.state,
				selectedType: state.type || "", 
				formData: { 
					...this.state.formData, 
					type: state.type || ""
				}, 
			}, () => {
				this.onParentSelectChange(state.project,"parent_id");
			});
		}
	}

	onChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } });};

	onBudgetChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: parseFloat(e.target.value) } });};
	
	onDateChange = (date) => {
		if(date) {
			const formatedDate = moment(date).format("DD-MM-YYYY");
			this.setState({ 
				selectedDate: date.toISOString(), 
				formData: { 
					...this.state.formData, 
					deadline: formatedDate
				}
			});
		}
	}
	
	onSelectChange = (option, name) => {
		if (option !== null) {
			this.setState({formData: { ...this.state.formData, [name]: option.value || "" }});
		}
	};

	onPackageChange = (option, name) => {
		if(option !== null) {
			this.setState({ formData: {...this.state.formData, [name]: option.value || "" } });
			this.setState({isLoadingPackageData: true, disableCustomer:true});
			this.packagesService.show(option.value).then((res) => {
				const tasks=[];
				const packAge = (res.data && res.data.package) ? res.data.package : null;
				const areas = (res.data && res.data.package && res.data.package.areas) ? res.data.package.areas : [];
				
				for (let index = 0; index < areas.length; index+=1) {
					tasks[index] = {user_id:null, area_package_id: areas[index].pivot && areas[index].pivot.id, full_name: "" };
				}		
			
				this.setState({
					isLoadingPackageData: false, 
					packageAreas: this.loadPackageAreas(packAge.areas),
					selectedCustomer: dataToSelectOption(packAge.customer_id,"id", packAge.company_name,"full_name" ),
					formData:{ ...this.state.formData, 
						tasks, status: "Active", 
						client_id: packAge.customer_id,
						budget: packAge.budget,
					}
				});

			}).catch((err) => {
				this.setState({ isLoadingPackageData: false, isLoadingAreas: false, });
				HandleError(err, this);
			});;
		}
	}

	onParentSelectChange = (option, name) => {
		if (option !== null) {
			this.setState({isLoadingCustomer: true, disableCustomer:true});
			new AdminService(this,`users/${option.client_id}/name`).index(0).then((res) => {
				this.setState({
					...this.state,
					isLoadingCustomer: false,
					selectedCustomer: dataToSelectOption(res.data.id,"id", res.data.full_company_name,"full_name" ),
					formData:{ ...this.state.formData, client_id: res.data.id || null }
				});
			}).catch((err) => {
				HandleError(err, this);
				this.setState({isLoadingCustomer:false});
			}).then(()=>{
				this.setState({isLoadingAreas:true});
				new AreasService(this).index(0,`customer_id=${option.client_id}`).then((res) => {
					this.setState({
						isLoadingAreas: false,
						areas: this.loadProjectAreas(res.data.areas),
						formData: {
							...this.state.formData,
							areas: []
						}
					});
				}).catch((err) => {
					this.setState({isLoadingAreas:false});
					HandleError(err, this);
				});
			});
			
			this.setState({ selectedProject: option, formData: { ...this.state.formData, [name]: option.id || "" }});
		} else {
			this.setState({ selectedProject: null, formData: { ...this.state.formData, [name]: null } });
		}
	}

	onCheckboxChange = (e) => {
    	this.setState({...this.state, directLogging: e.target.checked, formData: {...this.state.formData, [e.target.name]: e.target.checked }});
	}

	onTypeSelectChange = (option, name) => {
		if(option !== null) {
			switch(option.value) {
			case "standalone":
				this.setState({ selectedType: "standalone", formData: { ...this.state.formData, [name]: option.value || "" }, errors: {}});
				break;
			case "recurring": 
				this.setState({ selectedType: "recurring", formData: { ...this.state.formData, [name]: option.value || "" }, errors: {}});
				break;
			case "pay-as-u-go": 
				this.setState({ selectedType: "pay-as-u-go", formData: { ...this.state.formData, [name]: option.value || "" }, errors: {}});
				break;
			case "package": 
				this.getPackages();
				this.setState({ selectedType: "package", formData: { ...this.state.formData, [name]: option.value || "" }, errors: {}});
				break;
			case "extra-hours": 
				this.setState({selectedType: "extra-hours",formData: { ...this.state.formData, [name]: option.value || ""}, errors: {} });
				break;
			default: 
				break;
			}
		} 
	}

	onAsyncChange = (option, name, selected) => {
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.id || "" } });
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}
	
	onCustomerAsyncChange = (option, name, selected) => {
		if (option !== null) {
			this.setState({isLoadingAreas:true});
			new AreasService(this).index(0,`customer_id=${option.id}`).then((res) => {
				this.setState({
					isLoadingAreas: false,
					areas: this.loadProjectAreas(res.data.areas),
					formData: {
						...this.state.formData,
						areas: []
					}
				});
			}).catch((err) => {
				this.setState({isLoadingAreas:false});
				HandleError(err, this);
			});
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.id || "" } });
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}
	
	onPackageAsyncChange = (option, index) => {
		if (option !== null) {
			this.setState({
				formData:{
					...this.state.formData, 
					tasks:[
						...this.state.formData.tasks.map((item, index2)=>(
							index===index2 ? { area_package_id: item.area_package_id, user_id: option.id, full_name: option.full_name } : item
						))
					]
				}
			});
		}
	}

	onChangeAreaValue = (e, area) => {
		this.setState({
			formData: {
				...this.state.formData,
				areas: this.state.formData.areas.map((item) => (
					item.id !== area.id ? item
						:
						{
							id: area.id,
							name: area.name,
							value: parseFloat(e.target.value) > 0 ? parseFloat(e.target.value) : null,
						}
				))
			}
		});
	}

	onSubmit = (e) => {
		e.preventDefault();
		this.setState({saveProjectLoading: true, errors:{}});
		this.projectsService.store(this.state.formData).then((res) => {
			this.setState({saveProjectLoading: false});
			NotificationManager.success("Project created.", "Success!");
			this.props.history.goBack();
		}).catch((err) => {
			this.setState({saveProjectLoading: false});
			HandleError(err, this);
		});
	}

	getPackages = () => {
		const { packages } = this.state;
		if(packages && Array.isArray(packages) && packages.length < 1) {
			this.setState({ isLoadingPackages: true });
			this.packagesService.index().then((res) => {
				this.setState({
					isLoadingPackages: false,
					packages: this.loadPackages(res.data.data),
				});
			}).catch((err) => {
				this.setState({ isLoadingPackages: false });
				HandleError(err, this);
			});
		}
	}

	getProjectTypes = () => {
		const projectTypes = [
			{value: "standalone", label: "Standalone"},
			{value: "recurring", label: "Recurring"},
			{value: "pay-as-u-go", label: "Pay as you go"},
			{value: "package", label: "Package"},
			{value: "extra-hours", label: "Extra Hours"}
		];
		return projectTypes;
	}

	getProjectStatuses = () => {
		const projectStatuses = [
			{value: "Active", label: "Active"},
			{value: "NotActive ", label: "Inactive"},
			{value: "StandBy", label: "StandBy"},
			{value: "Finished", label: "Finished"}
		];
		return projectStatuses;
	}

	loadProjectAreas = (areas) => {
		if (areas && Array.isArray(areas)) {
			return areas.map((area) => ({ id: area.id, name: area.name, value: area.pivot ? area.pivot.hours.toString() : null }));
		}
		return [];
	}

	loadPackages = (packAges) => {
		if (packAges && Array.isArray(packAges)) {
			return packAges.map((p) => ( dataToSelectOption(p.id,"value", p.name,"label")) );
		}
		return [];
	}

	loadPackageAreas = (areas) => {
		if (areas && Array.isArray(areas)) {
			return areas.map((area) => ( dataToSelectOption(area.pivot && area.pivot.id,"value", area.name, "label") )); 
		}
		return [];
	}

	handleAsyncSearch = (input = null, attribute, extra, callback) => {
		if (!input || !input.replace(/\s/g, "").length) {
		 callback(null, { complete: true });
		 return;
		}
		this.asyncCallback(input, attribute, extra, callback);
	}

	asyncCallback = debounce((input, attribute, extra, callback) => {
		this.searchService.searchByAttribute(attribute, input, extra).then((res) => {
			callback(null, {options: res.data , complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 700);
	
	
	dropedNewArea = (newArea) => {
		this.setState((prevState)=>({
			areas: prevState.areas.filter((val, i) => (i !== newArea.index)),
			formData:{
				...this.state.formData,
				areas: [...this.state.formData.areas,newArea.area]
			}
		}));
	}

	removeNewArea = (removedArea,index)=>{
		this.setState((prevState) => ({
			areas:[...this.state.areas, removedArea],
			formData: {
				...this.state.formData,
				areas: prevState.formData.areas.filter((val, i) => (i !== index)),
			}
		}));
	}

	usersService = new AdminService(this,"users");    
	projectsService = new ProjectsService(this);
	packagesService = new PackagesService(this)
	searchService = new SearchService(this);
	
	render() {
    	const { 
			formData, errors, areas, saveProjectLoading, isLoadingAreas, isLoadingPackages, 
			selectedCustomer, selectedManager, selectedProject, selectedType, selectedDate,
			directLogging, packages, isLoadingPackageData, packageAreas,
		} = this.state;
    	const projectTypes = this.getProjectTypes();
		const projectStatuses = this.getProjectStatuses();
		return (
    		<React.Fragment>
    			<Row>
    				<form onSubmit={this.onSubmit}>
    					<Col md={6} sm={6} xs={12}>
    						<span className="column-title">Project details</span>
							{/** ******** General project fields ********** */}
    						<Row>
								{/* project type */}
								<Col md={6}>
    								<FormGroup validationState={errors.type && "error"}>
    									<ControlLabel>Project Type</ControlLabel>
    									<Select
    										onChange={(option) => { this.onTypeSelectChange(option, "type"); }}
    										name="type"
    										placeholder="Choose project type"
    										value={formData.type || ""}
    										options={projectTypes}
    										clearable={false}
											multi={false}											  										
    									/>
    									{errors.type && <InlineError text={errors.type} />}
    								</FormGroup>
    							</Col>
								{/* project name */}
    							<Col md={6}>
    								<FormGroup validationState={errors.name && "error"}>
    									<ControlLabel>Name</ControlLabel>
    									<FormControl type="text" name="name" placeholder="Enter project name" value={formData.name || ""} onChange={this.onChange} />
    									{errors.name && <InlineError text={errors.name} />}
    								</FormGroup>
    							</Col>
    						</Row>
							{/** *********end general project fields************* */}

							{/* Standlone project fields only */}
							{ 	(selectedType === "standalone") && 
								<StandaloneFields
									errors={errors}
									formData={formData}
									selectedDate={selectedDate}
									selectedManager={selectedManager}
									selectedCustomer={selectedCustomer}
									projectStatuses={projectStatuses}
									onBudgetChange={this.onBudgetChange}
									onDateChange={this.onDateChange}
									onSelectChange={this.onSelectChange}
									onAsyncChange={this.onAsyncChange}
									onCustomerAsyncChange={this.onCustomerAsyncChange}
									handleAsyncSearch={this.handleAsyncSearch}
								/>
							}

							{/* Recurring project fields only */}
							{ 	(selectedType === "recurring") && 
								<RecurringFields
									disableCustomer={this.state.disableCustomer}
									errors={errors}
									formData={formData}
									projectStatuses={projectStatuses}
									selectedProject={selectedProject}
									selectedDate={selectedDate}
									selectedManager={selectedManager}
									selectedCustomer={selectedCustomer}
									onBudgetChange={this.onBudgetChange}
									onDateChange={this.onDateChange}
									onSelectChange={this.onSelectChange}
									onAsyncChange={this.onAsyncChange}
									onCustomerAsyncChange={this.onCustomerAsyncChange}
									onParentSelectChange={this.onParentSelectChange}
									handleAsyncSearch={this.handleAsyncSearch}
								/>
							}

							{/* Pay as you go project fields only */}
							{ 	(selectedType === "pay-as-u-go") && 
								<PayAsYouGoFields
									disableCustomer={this.state.disableCustomer}
									errors={errors}
									formData={formData}
									projectStatuses={projectStatuses}
									selectedProject={selectedProject}
									selectedDate={selectedDate}
									selectedManager={selectedManager}
									selectedCustomer={selectedCustomer}
									onDateChange={this.onDateChange}
									onBudgetChange={this.onBudgetChange}
									onSelectChange={this.onSelectChange}
									onAsyncChange={this.onAsyncChange}
									onCustomerAsyncChange={this.onCustomerAsyncChange}
									onParentSelectChange={this.onParentSelectChange}
									handleAsyncSearch={this.handleAsyncSearch}
								/>
							}

							{/* Package project fields only */}
							{ 	(selectedType === "package") && 
								<PackageFields
									disableCustomer={this.state.disableCustomer}
									disabled={false}
									isLoadingPackages={isLoadingPackages}	
									errors={errors}
									formData={formData}
									projectStatuses={projectStatuses}
									packages={packages}
									selectedProject={selectedProject}
									selectedDate={selectedDate}
									selectedManager={selectedManager}
									selectedCustomer={selectedCustomer}
									onBudgetChange={this.onBudgetChange}
									onDateChange={this.onDateChange}
									onSelectChange={this.onSelectChange}
									onAsyncChange={this.onAsyncChange}
									onPackageChange={this.onPackageChange}
									onCustomerAsyncChange={this.onCustomerAsyncChange}
									handleAsyncSearch={this.handleAsyncSearch}
								/>
							}

							{/* Extra hours project fields only */}
							{ 	(selectedType === "extra-hours") && 
								<ExtraHoursFields
									disableCustomer={this.state.disableCustomer}
									errors={errors}
									formData={formData}
									selectedDate={selectedDate}
									selectedManager={selectedManager}
									selectedCustomer={selectedCustomer}
									selectedProject={selectedProject}
									projectStatuses={projectStatuses}
									onBudgetChange={this.onBudgetChange}
									onDateChange={this.onDateChange}
									onSelectChange={this.onSelectChange}
									onAsyncChange={this.onAsyncChange}
									onParentSelectChange={this.onParentSelectChange}
									onCustomerAsyncChange={this.onCustomerAsyncChange}
									handleAsyncSearch={this.handleAsyncSearch}
								/>
							}

							{/** ******** General project fields ********** */}
							<FormGroup validationState={errors.description && "error"}>
    							<ControlLabel>Description</ControlLabel>
    							<FormControl componentClass="textarea" name="description" placeholder="Enter project description" value={formData.description || ""} onChange={this.onChange}/>
								{errors.description && <InlineError text={errors.description} />}    						
							</FormGroup>
							{/** *********end general project fields************* */}

							{ (selectedType !== "package") && 
								<FormGroup validationState={errors.direct_logging && "error"}>
									<Checkbox name="direct_logging" inline onChange={this.onCheckboxChange} checked={directLogging}>
										Enable to log hours directly to this project
									</Checkbox> 
								</FormGroup>
							}
	
    					</Col>						
					 
						<Col md={6} sm={6} xs={12}>
							{ selectedType === "package" ?								
								<React.Fragment>
									<span className="column-title">Tasks</span>
									<div className={`package-area ${errors.tasks_error?"error":""}`}>
										{ isLoadingPackageData ? 
											<React.Fragment>
												<LoadingSVG />
											</React.Fragment> 
											:
											<Row>
												{packageAreas.map((item, index) => (
													<PackageArea  
														key={item.value}
														item={item}
														index={index}
														task={this.state.formData.tasks[index]}
														onPackageAsyncChange={this.onPackageAsyncChange}
														handleAsyncSearch={this.handleAsyncSearch}
													/>
												))}
												<Col md={12} sm={12}>{errors.tasks_error && <div className="alert alert-danger" role="alert">{errors.tasks_error}</div>}</Col>
											</Row>
										}
									</div>
								</React.Fragment>
								: 
								<React.Fragment>
									<span className="column-title">Areas</span>
									<div className="skills-container">
										<div className="all-skills">
											{ isLoadingAreas ?
												<React.Fragment>
													<LoadingSVG />
												</React.Fragment>
												:
												<React.Fragment>
													<AreasContainer											
														allAreas={areas}
														areas={formData.areas}
														errors={errors}
														onChangeAreaValue={this.onChangeAreaValue}
														dropedNewArea={this.dropedNewArea}
														removeNewArea={this.removeNewArea}
													/> 										
												</React.Fragment>
											}
										</div>
									</div>
								</React.Fragment>
							}
						</Col>
    					<Col md={12} sm={12} xs={12}>
    						<Button className="btn-crud" bsStyle="primary" disabled={saveProjectLoading} type="submit">{saveProjectLoading?"Saving...":"Save"}</Button>
    						{ saveProjectLoading ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }
    					</Col>
    				</form>
    			</Row>
    		</React.Fragment>
    	);
	}
}
ProjectCreateForm.defaultProps = {
	location: PropTypes.shape({
		state: null,
	}),
};

ProjectCreateForm.propTypes = {
	history:PropTypes.shape({
		goBack: PropTypes.func
	}).isRequired,
	location: PropTypes.shape({
		state: PropTypes.shape({
			project: PropTypes.shape({
				id: PropTypes.number,
				name: PropTypes.string,
				client_id: PropTypes.string
			}),
			type: PropTypes.string,
		}),
	})
};
export default withRouter(ProjectCreateForm);



// WEBPACK FOOTER //
// ./src/components/forms/projects/ProjectCreateForm.js